import React from 'react';
// import ssdIcon from '../assets/images/ssd-shredding.png';
// import hddIcon from '../assets/images/hdd-destruction.png';
// import ecycleIcon from '../assets/images/ecycle.png';

const features = [
    { icon: "ssdIcon", title: "On-Site SSD Shredding (2mm)", description: "We shred Solid State Drives (SSDs) to a 2mm particle size on-site, meeting the highest security standards and ensuring data is completely unrecoverable." },
    { icon: "hddIcon", title: "HDD Degaussing & Destruction", description: "Hard Disk Drives (HDDs) are first degaussed (magnetized) and then physically destroyed to guarantee complete data elimination beyond recovery." },
    { 
        icon: "ecycleIcon", 
        title: "Responsible E-Waste Recycling", 
        description: "After destruction, all electronic waste is handled and recycled in accordance with environmental regulations." 
    }
];

const SecureShredding = () => {
  return (
    <section id="shredding" className="py-16 bg-blue-700 text-white">
      <div className="container mx-auto px-6 text-center">
        <h3 className="text-base uppercase font-semibold text-blue-300">Secure Data Destruction</h3>
        <h2 className="text-3xl md:text-4xl font-extrabold my-3">Secure & Compliant Shredding Services</h2>
        <p className="max-w-3xl mx-auto mb-12 text-blue-100">
            Bitdeploy provides secure on-site data destruction to ensure your sensitive information is permanently eliminated, helping you meet compliance requirements and protect your company from data breaches.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
             <div key={index} className="bg-blue-800 p-8 rounded-lg shadow-lg flex flex-col items-center">
              {/* <img src={feature.icon} alt={`${feature.title} icon`} className="h-20 w-20 mb-4" /> */}
              <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-blue-200">{feature.description}</p>
            </div>
          ))}
        </div>
        <a href="#contact" className="mt-12 inline-block bg-white hover:bg-gray-200 text-blue-700 font-bold py-3 px-8 rounded-lg text-lg transition duration-300">
            Request Shredding Service
        </a>
      </div>
    </section>
  );
};

export default SecureShredding;